import React, { Component } from 'react';
import axios from 'axios';
import { handleWebinarValidation } from '../../../utils/helper-functions/form-handling';
import FormSubmit from '../form-buttons/form-submit';
import InputHoneypot from '../inputs/input-honeypot';
import InputRequired from '../inputs/input-required';
import InputDefault from '../inputs/input-default';
import InputSelect from '../inputs/input-select';
import InputDefaultTextArea from '../inputs/input-default-textarea';
import InputTextAreaRequired from '../inputs/input-textarea-required';

import styles from '../form.module.css';

class FormWebinar extends Component {
  constructor() {
    super();
    this.state = {
      first: '',
      last: '',
      email: '',
      company: '',
      title: '',
      honeypot: '',
      formErrors: {},
      submitted: 0,
    };
  }

  settings = {
    themeInput: '#000000',
  };

  captureFieldData = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.resetFieldError(event.target.name);
  };

  resetFieldError = name => {
    if (this.state.formErrors[name] !== '') {
      this.setState({ formErrors: { ...this.state.formErrors, [name]: '' } });
    }
  };

  // clearForm = () => {
  //   document.getElementById('form-contact').reset();
  //   this.setState({
  //     file: {},
  //   });
  // };

  formValidation = () => {
    const validation = handleWebinarValidation(
      this.state.first,
      this.state.last,
      this.state.email,
      this.state.company,
      this.state.title
    );
    this.setState({
      formErrors: validation.errors,
    });
    if (validation.formIsValid !== true) {
      return;
    }
    this.postData();
  };

  buildFormData = () => {
    const { first, last, email, title, company } = this.state;
    if (typeof window !== 'undefined') {
      const formData = new FormData();
      const fields = {
        'your-first': first,
        'your-last': last,
        'your-email': email,
        'your-title': title,
        'your-company': company,
        'your-name': `${first} ${last}`,
      };
      Object.keys(fields).forEach(key => {
        formData.append(key, fields[key]);
      });

      return formData;
    }
  };

  submissionSuccess = () => {
    this.setState(
      {
        submitted: 1,
      },
      this.resetSubmission()
    );
  };

  submissionLoading = () => {
    this.setState({
      submitted: 2,
    });
  };

  resetSubmission = () => {
    setTimeout(() => {
      this.setState(
        {
          first: '',
          last: '',
          email: '',
          company: '',
          title: '',
          submitted: 0,
        }
        // this.clearForm()
      );
    }, 3000);
  };

  postData = () => {
    if (this.state.honeypot) {
      return;
    }
    const formData = this.buildFormData();

    this.submissionLoading();
    axios({
      url: `${process.env.PROTOCOL}://${process.env.API_URL}/wp-json/contact-form-7/v1/contact-forms/${this.props.formID}/feedback`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(response => {
        this.submissionSuccess();
        this.props.unlock();
      })
      .catch(error => {
        console.log('Error', error);
      });
  };

  captureSelectData = selectValue => {
    this.setState({
      title: selectValue,
    });
  };

  submitForm = event => {
    event.preventDefault();
    this.formValidation();
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <form id="form-contact">
            <div className={[styles.row, styles.rowTwo].join(' ')}>
              <div className={styles.inputWrapper}>
                <InputRequired
                  formErrors={this.state.formErrors.first}
                  captureFieldData={this.captureFieldData}
                  theme={this.settings.themeInput}
                  name={'first'}
                  placeholder={'First Name*'}
                  type={'text'}
                />
              </div>
              <div className={styles.inputWrapper}>
                <InputRequired
                  formErrors={this.state.formErrors.last}
                  captureFieldData={this.captureFieldData}
                  theme={this.settings.themeInput}
                  name={'last'}
                  placeholder={'Last Name*'}
                  type={'text'}
                />
              </div>
            </div>
            <div className={[styles.row, styles.rowTwo].join(' ')}>
              <div className={styles.inputWrapper}>
                <InputRequired
                  formErrors={this.state.formErrors.company}
                  captureFieldData={this.captureFieldData}
                  theme={this.settings.themeInput}
                  name={'company'}
                  placeholder={'Company*'}
                  type={'text'}
                />
              </div>
              <div className={styles.inputWrapper}>
                <InputDefault
                  formErrors={this.state.formErrors.title}
                  captureFieldData={this.captureFieldData}
                  theme={this.settings.themeInput}
                  name={'title'}
                  placeholder={'Job Title'}
                  type={'text'}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.inputWrapper}>
                <InputRequired
                  formErrors={this.state.formErrors.email}
                  captureFieldData={this.captureFieldData}
                  theme={this.settings.themeInput}
                  name={'email'}
                  placeholder={'Email*'}
                  type={'email'}
                />
              </div>
            </div>

            <InputHoneypot captureFieldData={this.captureFieldData} />

            <FormSubmit
              submitForm={this.submitForm}
              submitted={this.state.submitted}
            />
          </form>
        </div>
      </React.Fragment>
    );
  }
}

export default FormWebinar;



// WEBPACK FOOTER //
// ./src/components/form/form-webinar/index.js